import React, { useRef, useState } from "react"
import { Box, Container, Flex, Heading, Grid } from "theme-ui"
import { BsChevronRight } from "react-icons/bs"

const JobList = ({ block, pageTitle }) => {
  const { title, jobs, description } = block
  return (
    <Container
      sx={{
        zIndex: 1,
        position: "relative",
      }}
    >
      <Flex
        sx={{
          flexDirection: "column",
          pt: [5, 7],
        }}
      >
        <Box>
          {
            <Heading
              color="primary"
              as="h2"
              variant="h1"
              sx={{
                mt: [0, 0],
                borderBottom: "1px solid",
                borderColor: "lightGrey",
                fontWeight: "300",
                pb: [4],
              }}
            >
              {pageTitle || title}
            </Heading>
          }
        </Box>
      </Flex>
      {jobs.map(job => (
        <Grid columns={["1fr", "1fr", ".3fr .7fr"]}>
          <Box
            sx={{
              display: ["none", "none", "block"],
            }}
          ></Box>
          <SingleJob data={job} />
        </Grid>
      ))}
      <Box
        sx={{
          pt: [3, 4],
        }}
        dangerouslySetInnerHTML={{ __html: description }}
      />
    </Container>
  )
}

const SingleJob = ({ data }) => {
  const maxHeightRef = useRef(2500)
  const { description } = data
  const [show, setShow] = useState(false)
  return (
    <Box
      data-job={data.title}
      sx={{
        mt: [3, 4],
      }}
    >
      <Flex
        onClick={() => setShow(!show)}
        sx={{
          pb: [3, 4],
          borderBottom: "1px solid",
          borderColor: "dark",
          alignItems: "center",
          justifyContent: "space-between",
          cursor: "pointer",
          "&:hover": {
            ".icon": {
              backgroundColor: "primary",
              svg: {
                fill: "light",
              },
            },
          },
        }}
      >
        <Heading
          as="h2"
          variant="h3"
          sx={{
            fontSize: [3, 5],
            my: [0, 0],
            color: "dark",
            fontWeight: "300",
          }}
        >
          {data.title}
        </Heading>
        <Box
          as="span"
          className="icon"
          sx={{
            border: "1px solid",
            borderColor: "dark",
            width: "40px",
            minWidth: "40px",
            minHeight: "40px",
            height: "40px",
            borderRadius: "100%",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            svg: {
              transform: show ? "rotate(90deg)" : "rotate(0deg)",
              transition: "transform .3s",
            },
          }}
        >
          <BsChevronRight size={24} />
        </Box>
      </Flex>
      <Box
        className={`${show ? "show-accordion" : null} `}
        sx={{
          overflow: "hidden",
          maxHeight: 0,
          transition: "max-height .3s",
          "&.show-accordion": {
            pt: [4, 6],
            maxHeight: maxHeightRef.current,
            transition: "max-height .3s",
          },
          li: {
            borderBottom: "none",
            mb: [0],
            alignItems: "flex-start",
            "&:before": {
              height: "auto",
              minHeight: "auto",
              lineHeight: "1.4",
            },
          },
          fontSize: [2, 3],
          fontWeight: "300",
          p: {
            fontWeight: "300",
            fontSize: [2, 3],
          },
        }}
        dangerouslySetInnerHTML={{ __html: description }}
      ></Box>
    </Box>
  )
}

export default JobList
